import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment-jalaali";
import { putData } from "../../../../Core/Projects/action";
import { changeData } from "../../../../Core/ChangeValues/action";
import styles from "../../../../Assets/Styles/Components/Book/BookTime/HourSelection/hourSelection.module.css";

class HourSelection extends Component {
  constructor() {
    super();
    this.state = {
      // selectedTime: null,
    };
  }

  componentDidMount() {
    const w = window.innerWidth;
    if (w < 768) {
      document
        .querySelector(`.${styles.hourSelection}`)
        .scrollIntoView({ behavior: "smooth", top: 100 });
    }
  }

  selectTime = (i) => () => {
    const { slug, data } = this.props.project;
    // this.setState({ selectedTime: i });
    this.props.onChange(i);
    const time = `${moment(this.props.day, "jYYYY/jM/jD").format(
      "YYYY-M-D"
    )} ${i}:00`;
    this.props.putData(slug, {
      ...data,
      skip_start_time: false,
      start_time: time,
      step: this.props.history.location.pathname.slice(1).split("/")[1],
    });
    this.props.changeData();
  };

  p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

  goNext = () => {
    this.props.history.push(
      `/book/photographer?slug=${this.props.project.slug}`
    );
  };

  render() {
    const morning = this.props.hours[0].times;
    const noon = this.props.hours[1].times;
    const afternoon = this.props.hours[2].times;
    return (
      <div className={styles.hourSelection}>
        <div className={styles.header}> {this.props.dayTitle} </div>
        <div className={styles.headerTimes}>
          <div> صبح </div>
          <div> ظهر </div>
          <div> شب </div>
        </div>
        <div className={styles.hours}>
          <ul>
            {morning.map((i) => (
              <li
                key={i}
                onClick={this.selectTime(this.p2e(i))}
                className={
                  this.props.time === this.p2e(i) ? styles.selected : ""
                }
              >
                {this.p2e(i)}
              </li>
            ))}
          </ul>
          <ul>
            {noon.map((i) => (
              <li
                key={i}
                onClick={this.selectTime(this.p2e(i))}
                className={
                  this.props.time === this.p2e(i) ? styles.selected : ""
                }
              >
                {this.p2e(i)}
              </li>
            ))}
          </ul>
          <ul>
            {afternoon.map((i) => (
              <li
                key={i}
                onClick={this.selectTime(this.p2e(i))}
                className={
                  this.props.time === this.p2e(i) ? styles.selected : ""
                }
              >
                {this.p2e(i)}
              </li>
            ))}
          </ul>
        </div>
        {this.props.time !== "" && (
          <div className={styles.btnNextStep} onClick={this.goNext}>
            قدم بعدی{" "}
            <i
              className="fa fa-arrow-left"
              aria-hidden="true"
              style={{ marginRight: "5px", verticalAlign: "sub" }}
            >
              {" "}
            </i>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    project: state.project,
  };
};
export default connect(mapStateToProps, { putData, changeData })(
  withRouter(HourSelection)
);
